<template>
  <div
    :class="[
      'flex w-full flex-col items-center rounded-lg bg-white box-border',
      isDesktop ? 'gap-4 p-4' : 'gap-3 px-4 pt-3 pb-4',
    ]"
  >
    <p
      :class="[
        'w-full text-center font-bold leading-6 text-primary-500',
        isDesktop ? 'text-base' : 'text-sm',
      ]"
    >
      トラベリストはアプリでさらにお得！
    </p>
    <div
      :class="[
        'w-full rounded-lg bg-primary-50 box-border',
        isDesktop
          ? 'flex items-center justify-center gap-8 p-4'
          : 'flex flex-col gap-1 px-4 py-2',
      ]"
    >
      <template v-for="(appeal, index) in appeals">
        <div
          :key="appeal.text"
          :class="[
            'flex items-center gap-1',
            isDesktop
              ? index > 0 && 'border-l border-slate-300 pl-8'
              : index > 0 && 'border-t border-slate-300 pt-1',
          ]"
        >
          <i
            :class="[
              'w-6 shrink-0 text-center text-xs text-fig-gray-500',
              appeal.icon,
            ]"
            aria-hidden="true"
          />
          <p class="text-xs leading-5 text-ink">{{ appeal.text }}</p>
        </div>
        <!-- ポイント提携先ロゴ（1つ目の訴求のみ、SP限定。Figma node 6298:59074） -->
        <div
          v-if="!isDesktop && index === 0"
          :key="`${appeal.text}-logos`"
          class="flex items-center gap-2 pl-6"
        >
          <img
            src="/travelist/sp/img/logo-paypay-point.png"
            alt="PayPayポイント"
            class="size-6"
          />
          <img
            src="/travelist/sp/img/logo-r-point.png"
            alt="Rポイント"
            class="size-6"
          />
          <img
            src="/travelist/sp/img/logo-amazon.png"
            alt="Amazon"
            class="h-4 w-auto"
          />
          <p class="text-xs leading-5 text-ink">など</p>
        </div>
      </template>
    </div>
    <div class="flex w-full max-w-[300px] items-center gap-1">
      <a :href="storeUrl" class="block w-1/2">
        <img
          src="/travelist/sp/img/badge-apple-store.png"
          alt="トラベリスト 格安航空券予約(App Store)"
          class="w-full align-middle"
        />
      </a>
      <a :href="storeUrl" class="block w-1/2">
        <img
          src="/travelist/sp/img/badge-google-play.png"
          alt="トラベリスト 格安航空券(Google Play)"
          class="w-full align-middle"
        />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
// isDesktop はグローバル mixin（src/main.js=true, src_sp/main.js=false）を
// テンプレートで直接参照する（CompleteStepper.vue と同様のパターン）。
// 表示条件（isNative/A-Bテスト判定）は呼び出し元が制御するため、本コンポーネントは
// props/emitを持たない静的コンテンツのみ（design.md「アプリダウンロードバナー共通化設計」）。
// 呼び出し元（ApplicationComplete.vue／ApplicationHotelComplete.vue）は現状どおりSP限定で
// マウントするため、isDesktop分岐のPC側パスは実運用では到達しない（Histoireのプレビュー用途のみ）。
// SP実測値はFigma node 6298:59066（PC node 6298:60989 と対応）。ポイント提携先ロゴ・
// ストアバッジの並び順（App Store→Google Play）はSP側のみFigmaに一致させた。

// 既存のSP専用インラインmarkup（ApplicationComplete.vue）と同一のストアリンクURL・バッジ画像を流用。
const storeUrl = 'https://travelist.onelink.me/VSoR/f2ut355z';

// アイコンは要件7.4の3訴求（一次ソースはrequirements.md）。文言はFigma node 6298:60989 と
// 一致するが、3つ目のみFigmaのモックアップ表記「¥500OFF！」・requirements.mdの表記
// 「次回のご予約が¥500OFFになる」のいずれとも異なる（要確認、要件確認が取れるまでは
// 現状の文言を維持する）。
const appeals = [
  { icon: 'fa-solid fa-rotate', text: '貯めたポイントを他社ポイントに交換' },
  { icon: 'fa-solid fa-user', text: 'マイページで予約の確認が簡単' },
  { icon: 'fa-solid fa-tag', text: '次回予約で使える500円OFFクーポン' },
];
</script>
